var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlutenFree = function SvgGlutenFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m30 30.617-2.652-2.652M22.222 30.517a2.304 2.304 0 0 0 2.248-2.729 2.31 2.31 0 0 0-2.73-2.248c-1.717.167-4.868 1.595-4.735 2.97.133 1.375 3.495 2.173 5.217 2.007v0ZM15.968 24.265a2.306 2.306 0 0 0 2.249-2.728 2.305 2.305 0 0 0-2.729-2.249c-1.718.167-4.87 1.595-4.736 2.969.133 1.373 3.5 2.173 5.216 2.008ZM29.9 22.833a2.306 2.306 0 0 1-2.733 2.254 2.308 2.308 0 0 1-2.249-2.73c.167-1.717 1.595-4.869 2.97-4.737 1.375.132 2.179 3.5 2.012 5.213ZM23.648 16.585a2.303 2.303 0 0 1-2.728 2.248 2.304 2.304 0 0 1-2.253-2.728c.166-1.718 1.595-4.87 2.968-4.737 1.373.134 2.18 3.499 2.013 5.217ZM14.973 12.055a2.304 2.304 0 0 1 0 3.535 2.303 2.303 0 0 1-3.535 0c-1.22-1.22-2.743-4.333-1.768-5.303.975-.97 4.083.546 5.303 1.768v0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 38.727c10.355 0 18.75-8.395 18.75-18.75 0-10.356-8.395-18.75-18.75-18.75S1.25 9.62 1.25 19.977c0 10.355 8.395 18.75 18.75 18.75ZM33.258 6.718l-4.508 4.509M6.743 33.232l4.507-4.505"
  })));
};
export default SvgGlutenFree;